import React from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom'
import Navbar from './components/Navbar'
import Home from './pages/Home'
import Skills from './pages/Skills'
import Projects from './pages/Projects'
import Achievements from './pages/Achievements'
import Experiences from './pages/Experiences'

const App = () => {
  return <main className='bg-dark'>
    <Router>
      <Navbar />

      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/skills' element={<Skills />} />
        <Route path='/projects' element={<Projects />} />
        <Route path='/achievements' element={<Achievements />} />
        <Route path='/experiences' element={<Experiences />} />
      </Routes>
    </Router>
  </main>
}

export default App